const loadWidgets = ({ commit }, payload) => {
    commit('LOAD_WIDGETS', payload);
};

export default {
    loadWidgets,
};
